<template>
    <div>
        <Breadcrumbs main="Accessories" title="Accessories Ad Views" />
		
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							
							<div class="col-md-12 project-list page-subtitle">
									<div class="row">
										<div class="col-md-10 d-flex">
											<span style="font-size: 20px; font-weight: bolder;">Accessories Ad Views</span>
										</div>
										<div class="col-md-2 float-end">
											<a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='fa fa-chevron-left'></i> Back</a>
										</div>
									</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
									<div class="row">
										<div class="col-md-9">
											<label class="d-flex listing-length"><span>Show</span>
												<select class="form-select" v-model="listing_length" @change="fetchClicks()">
													<option value="5">5</option>
													<option value="10">10</option>
													<option value="20">20</option>
												</select>
												<span>entries</span>
											</label>
										</div>
										<div class="col-md-3">
											<input type="text" class="form-control" placeholder="Search"  v-model="keyword" @keyup="fetchClicks()"/>
										</div>
									</div>
							</div>

							<div class="row">
								<div class="col-12">
									<b-button v-if="Boolean(reports.length)" variant="primary" class="mb-3 btn-sm" @click="generatePDF()">PDF</b-button>
								</div>
							</div>
							
							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Name</th>
											<th>Contact</th>
											<th>Location</th>
											<th>Clicks</th>
											<th>Last Viewed On</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(reports.length)">
										<tr v-for="report in reports" :key="report.id">
											<td>{{report.user_name}}</td>
											<td><p style="width: 200px">{{ report.country_code }}{{ report.user_phone }}<br>{{report.user_email}}</p></td>
											<td>{{report.user_location}}</td>
											<td>{{ report.clicks }}</td>
											<td>
												<span v-if="report.updated_at">{{ $filters.formatDateTime(report.updated_at) }}</span>
												<span v-else></span>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="5" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchClicks(page.url + '&type=accessory' + '&limit=' + listing_length + '&ad_id=' + ad_id)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>	
</template>


<script>
	export default {
		name: "AccessoryClicks",
		data() {
			return {
				reports: [],
			
				pagination: {},				
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				type: 'accessory',
				token: "",
				errors: {},
				ad_id: 0,
				source: 'existing',
			};
		},
		mounted() {
			
		},

		created() {
			this.checkSource();
			this.fetchClicks();
		},

		methods: {
			checkSource() {
				if(localStorage.back_url) {
					let page = localStorage.back_url;
					if(page.includes('sold')) {
						this.source = 'sold';
					} else {
						this.source = 'existing';
					}
				}
			},

			fetchClicks(page_url = null) {
				this.ad_id = this.$route.params.id;
				let url = "/api/admin/ad_views?type=accessory&ad_id=" + this.$route.params.id + "&limit=" + this.listing_length;
				page_url = page_url || url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						//console.log(responseData);
						this.reports = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},


			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			generatePDF() {
				this.getToken();
				let page_url = "/api/admin/ad_views_pdf?type=accessories&ad_id=" + this.ad_id;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
					.then((response) => {
						//console.log(response);
						let blob = new Blob([response.data], { type: "application/pdf" });
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "accessories-clicks-" + this.ad_id + ".pdf";
						link.click();
						
					})
					.catch((err) => console.log(err));
			},
			
		},
	};
</script>
